// Services/registrationAPI.js
import axios from "axios";
import api from "../api";
import { RegistrationEndpoints,AuthEndpoints } from "../api_endpoints";
import { DashboardEndpoints } from "../api_endpoints";
import { encryptPassword } from '../../utils/passwordEncryption';

const { 
    CHECK_USERNAME,
    CHECK_EMAIL,
    CHECK_MOBILE,
    CHECK_USER_CODE,
    CHECK_PLACEMENT_POSITION,
    SEND_EMAIL_OTP,
    VERIFY_EMAIL_OTP,
    REGISTER
} = RegistrationEndpoints;

const { 
    LOGIN_API, 
    SEND_FORGOT_PASSWORD_OTP, 
    VERIFY_FORGOT_PASSWORD_OTP, 
    RESET_PASSWORD 
} = AuthEndpoints;

const { 
    REGISTER_PAYMENT,
    ACTIVE_SELF_BY_WALLET,
    FUEL_UP_MAIN_VAULT,
    GET_USER_PROFILE,
    GET_ALL_PLAN_AMOUNTS,
    UPGRADE_PLAN,
    GET_ALL_PLANS,
    CHANGE_PASSWORD,
    GET_WALLET_TRANSACTION,
    GET_REGISTER_PAYMENT_LIST,
    GET_DIRECT_BY_USERCODE,
    GET_PLACEMENT_BY_USERCODE,
    PLAN_UPGRADE_BY_MAIN_VAULT,
    GET_FUEL_WALLET_PAYMENT_LIST,
    GET_DIRECT_LEVEL_INCOME_LIST,
    GET_TEAM_INCOME_LIST,
    GET_BINARY_INCOME,
GET_LOWEST_INCOME_BONUS,
GET_MAX_INCOME_BONUS,
GET_MAX_DIRECT_BONUS,
GET_ZERO_INCOME_BONUS,
GET_PACKAGE_UPGRADE_LIST,
GET_USER_BY_EMAIL,
ACTIVE_REGISTER_USER_BY_WALLET,
SENT_WALLET,
GET_USER_WALLET_BALANCE,
DASHBOARD_API,
ADD_BOND,
GET_UNUSED_BOND_KEYS,
GET_USED_BOND_KEYS,
 CHECK_PAYMENT_STATUS,
 ACTIVE_ID_BY_BOND_KEY
} = DashboardEndpoints;

export const adminLoginApi = async (loginId, password) => {
  try {
    // Encrypt password before sending
    const encryptedPassword = encryptPassword(password);
    
    // const response = await fetch(`${API_URL}/admin-login`, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({
    //     login_id: loginId,
    //     password: encryptedPassword
    //   })
    // });

    // const result = await response.json();
    // return result;
  } catch (error) {
    console.error('Admin login API error:', error);
    throw error;
  }
};


export const ActiveIdByBondKey = async (authToken, bond_key) => {
    try {
         const formData = new FormData();
        formData.append('bond_key', bond_key);
       const response = await api.post(ACTIVE_ID_BY_BOND_KEY, formData, {
             headers: {
                'Authorization': `Bearer ${authToken}`,
                'Accept': 'application/json',
            }
        });
        console.log('Dashboard data response:', response);
        return response;
    } catch (error) {
        console.error('Error fetching dashboard data:', error);
        throw error;
    }
};


export const checkPaymentStatusApi = async (paymentId) => {
  let result = { 
    status: false, 
    data: null, 
    message: '' 
  };
  
  try {
    const response = await api.get(`${DashboardEndpoints.CHECK_PAYMENT_STATUS}/${paymentId}`);
    
    console.log("Check Payment Status Response:", response);
    
    if (response.data) {
      if (response.data.status === true) {
        result = {
          status: true,
          data: response.data.data,
          message: response.data.message || 'Payment verified successfully'
        };
      } else {
        result.message = response.data.message || 'Payment verification failed';
      }
    }
  } catch (error) {
    console.error("CHECK_PAYMENT_STATUS_API_ERROR..........", error);
    result.message = error.response?.data?.message || 'An error occurred while checking payment status';
  }
  return result;
};

export const getusedBondKeysApi = async (authToken, page = 1, perPage = 10) => {
  let result = { 
    status: false, 
    data: null, 
    message: '',
    pagination: null
  };
  
  try {
    const formData = new FormData();
    formData.append('per_page', perPage);
    
    const response = await api.post(`${GET_USED_BOND_KEYS}?page=${page}`, formData, {
      headers: {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'multipart/form-data',
      }
    });
    
    console.log("Get Unused Bond Keys Response:", response);
    
    if (response.data) {
      if (response.data.status === true) {
        result = {
          status: true,
          data: response.data.data,
          message: response.data.message || 'Bond keys fetched successfully',
          pagination: response.data.pagination
        };
      } else {
        result.message = response.data.message || 'Failed to fetch bond keys';
      }
    }
  } catch (error) {
    console.error("GET_UNUSED_BOND_KEYS_API_ERROR..........", error);
    result.message = error.response?.data?.message || 'An error occurred while fetching bond keys';
  }
  return result;
};
// In ProductAPI.js, add these functions:
export const getUnusedBondKeysApi = async (authToken, page = 1, perPage = 10) => {
  let result = { 
    status: false, 
    data: null, 
    message: '',
    pagination: null
  };
  
  try {
    const formData = new FormData();
    formData.append('per_page', perPage);
    
    const response = await api.post(`${GET_UNUSED_BOND_KEYS}?page=${page}`, formData, {
      headers: {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'multipart/form-data',
      }
    });
    
    console.log("Get Unused Bond Keys Response:", response);
    
    if (response.data) {
      if (response.data.status === true) {
        result = {
          status: true,
          data: response.data.data,
          message: response.data.message || 'Bond keys fetched successfully',
          pagination: response.data.pagination
        };
      } else {
        result.message = response.data.message || 'Failed to fetch bond keys';
      }
    }
  } catch (error) {
    console.error("GET_UNUSED_BOND_KEYS_API_ERROR..........", error);
    result.message = error.response?.data?.message || 'An error occurred while fetching bond keys';
  }
  return result;
};

// Add to ProductAPI.js
export const addBondKeysApi = async (authToken, quantity) => {
  let result = { 
    status: false, 
    data: null, 
    message: '' 
  };
  
  try {
    const formData = new FormData();
    formData.append('quantity', quantity);
    
    const response = await api.post(ADD_BOND, formData, {
      headers: {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'multipart/form-data',
      }
    });
    
    console.log("Add Bond Keys Response:", response);
    
    if (response.data) {
      if (response.data.status === true) {
        result = {
          status: true,
          data: response.data.data,
          message: response.data.message || 'Bond keys added successfully'
        };
      } else {
        result.message = response.data.message || 'Failed to add bond keys';
      }
    }
  } catch (error) {
    console.error("ADD_BOND_KEYS_API_ERROR..........", error);
    result.message = error.response?.data?.message || 'An error occurred while adding bond keys';
  }
  return result;
};

// Add this function to your existing ProductAPI.js
export const getUserDashboardApi = async (token) => {
    try {
       const response = await api.post(DASHBOARD_API, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });
        console.log('Dashboard data response:', response);
        return response;
    } catch (error) {
        console.error('Error fetching dashboard data:', error);
        throw error;
    }
};

// Services/Operations/PaymentAPI.js (or update your existing file)
// Add these functions to your existing ProductAPI.js file

// Search User by Email API
export const searchUserByEmailApi = async (authToken, email) => {
    let result = { 
        status: false, 
        data: null, 
        message: '' 
    };
    
    try {
        const formData = new FormData();
        formData.append('email', email);
        
        const response = await api.post(GET_USER_BY_EMAIL, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        console.log("Search User by Email Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data,
                    message: response.data.message || 'User found successfully'
                };
            } else {
                result.message = response.data.message || 'User not found';
            }
        }
    } catch (error) {
        console.error("SEARCH_USER_BY_EMAIL_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while searching user';
    }
    return result;
};

// Active Register User by Wallet API (Fixed $5 transfer)
export const activeRegisterUserByWalletApi = async (authToken, email) => {
    let result = { 
        status: false, 
        data: null, 
        message: '' 
    };
    
    try {
        const formData = new FormData();
        formData.append('email', email);
        
        const response = await api.post(ACTIVE_REGISTER_USER_BY_WALLET, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        console.log("Active Register User by Wallet Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data,
                    message: response.data.message || 'User activated successfully'
                };
            } else {
                result.message = response.data.message || 'Failed to activate user';
            }
        }
    } catch (error) {
        console.error("ACTIVE_REGISTER_USER_BY_WALLET_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while activating user';
    }
    return result;
};

// Send Wallet Transfer API (Custom amount)
export const sendWalletTransferApi = async (authToken, email, walletType, amount) => {
    let result = { 
        status: false, 
        data: null, 
        message: '' 
    };
    
    try {
        const formData = new FormData();
        formData.append('email', email);
        formData.append('wallet_type', walletType);
        formData.append('amount', amount);
        
        const response = await api.post(SENT_WALLET, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        console.log("Send Wallet Transfer Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data,
                    message: response.data.message || 'Transfer successful'
                };
            } else {
                result.message = response.data.message || 'Transfer failed';
            }
        }
    } catch (error) {
        console.error("SEND_WALLET_TRANSFER_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while transferring';
    }
    return result;
};

// Get User Wallet Balance API
export const getUserWalletBalanceApi = async (authToken) => {
    let result = { 
        status: false, 
        data: null, 
        message: '' 
    };
    
    try {
        const response = await api.get(GET_USER_WALLET_BALANCE, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            }
        });
        
        console.log("Get User Wallet Balance Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data,
                    message: response.data.message || 'Wallet balance fetched successfully'
                };
            } else {
                result.message = response.data.message || 'Failed to fetch wallet balance';
            }
        }
    } catch (error) {
        console.error("GET_USER_WALLET_BALANCE_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching wallet balance';
    }
    return result;
};

// Note: You already have activateSelfByWalletApi, so you might want to check if it's the same as activeRegisterUserByWalletApi
// If they are the same, you can remove one of them

// Get Register Payment List API - Updated to use your api instance
export const getRegisterPaymentListApi = async (authToken, filters = {}) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        summary: {
            totalAmount: 0,
            totalCount: 0
        }
    };
    
    try {
        // Build query parameters using axios params
        const params = {
            ...(filters.date && { date: filters.date }),
            ...(filters.month && { month: filters.month }),
            ...(filters.year && { year: filters.year }),
            ...(filters.status && { status: filters.status }),
            ...(filters.payment_mode && { payment_mode: filters.payment_mode })
        };
        
        const response = await api.get(GET_REGISTER_PAYMENT_LIST, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            params: params // Pass query parameters
        });
        
        console.log("Get Register Payment List Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                // Calculate totals
                const totalAmount = response.data.data?.reduce((sum, item) => {
                    return sum + (parseFloat(item.payment_amount) || 0);
                }, 0) || 0;
                
                const totalCount = response.data.data?.length || 0;
                
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Payment reports fetched successfully',
                    summary: {
                        totalAmount: totalAmount,
                        totalCount: totalCount
                    }
                };
            } else {
                result.message = response.data.message || 'Failed to fetch payment reports';
            }
        }
    } catch (error) {
        console.error("GET_REGISTER_PAYMENT_LIST_API_ERROR..........", error);
        
        // Handle different error cases
        if (error.response) {
            // Server responded with error status
            if (error.response.status === 401) {
                result.message = 'Session expired. Please login again.';
            } else {
                result.message = error.response.data?.message || `Server error: ${error.response.status}`;
            }
        } else if (error.request) {
            // Request made but no response
            result.message = 'Network error. Please check your connection.';
        } else {
            // Other errors
            result.message = error.message || 'An error occurred while fetching payment reports';
        }
    }
    
    return result;
};

// Get Wallet Transaction API
// In your getWalletTransactionApi function, make sure you're returning all data
export const getWalletTransactionApi = async (authToken, walletType, page = 1, perPage = 15) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        pagination: {},
        filter_wallet: {}  // Make sure this is included
    };
    
    try {
        const formData = createFormData({
            wallet_type: walletType,
            page: page,
            per_page: perPage
        });

       const response = await api.post(GET_WALLET_TRANSACTION, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        console.log("Full API Response:", response.data); // Log the full response
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Success',
                    pagination: response.data.pagination || {},
                    filter_wallet: response.data.filter_wallet || {}  // Ensure this is extracted
                };
            } else {
                result.message = response.data.message || 'Failed to fetch transactions';
            }
        }
    } catch (error) {
        console.error("Error fetching wallet transactions:", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching transactions';
    }
    return result;
};

// Fuel Up Main Vault API
export const fuelUpMainVaultApi = async (authToken, amount, hashId) => {
    let result = { status: false, data: null, message: '' };
    try {
        const formBody = createFormUrlEncoded({
            amount: amount,
            hash_id: hashId
        });

        const response = await api.post(FUEL_UP_MAIN_VAULT, formBody, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Fuel Up Main Vault Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                data: response.data.data,
                message: response.data.message || 'Main vault fueled successfully'
            };
        } else {
            result.message = response.data?.message || 'Failed to fuel vault';
        }
    } catch (error) {
        console.error("FUEL_UP_MAIN_VAULT_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fueling vault';
    }
    return result;
};

// In Services/Operations/ProductAPI.js or create a new file
export const getPackageUpgradeListApi = async (authToken) => {
    let result = { 
        status: false, 
        data: [], 
        message: ''
    };
    
    try {
        const response = await api.get(GET_PACKAGE_UPGRADE_LIST, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            }
        });
        
        console.log("Get Package Upgrade List Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Package upgrade list fetched successfully'
                };
            } else {
                result.message = response.data.message || 'Failed to fetch package upgrade list';
            }
        }
    } catch (error) {
        console.error("GET_PACKAGE_UPGRADE_LIST_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching package upgrade list';
    }
    return result;
};


export const getZeroIncomeBonusApi = async (authToken, page = 1, perPage = 15) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        pagination: {}
    };
    
    try {
        const formData = new FormData();
        formData.append('per_page', perPage);
        formData.append('page', page);
        
        const response = await api.post(GET_ZERO_INCOME_BONUS, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        console.log("Zero Income Bonus Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Zero income bonus fetched successfully',
                    pagination: response.data.pagination || {}
                };
            } else {
                result.message = response.data.message || 'Failed to fetch zero income bonus';
            }
        }
    } catch (error) {
        console.error("GET_ZERO_INCOME_BONUS_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching zero income bonus';
    }
    return result;
};
export const getMaxDirectBonusApi = async (authToken, page = 1, perPage = 15) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        pagination: {}
    };
    
    try {
        const formData = new FormData();
        formData.append('per_page', perPage);
        formData.append('page', page);
        
        const response = await api.post(GET_MAX_DIRECT_BONUS, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        console.log("Max Direct Bonus Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Max direct bonus fetched successfully',
                    pagination: response.data.pagination || {}
                };
            } else {
                result.message = response.data.message || 'Failed to fetch max direct bonus';
            }
        }
    } catch (error) {
        console.error("GET_MAX_DIRECT_BONUS_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching max direct bonus';
    }
    return result;
};

export const getMaxIncomeBonusApi = async (authToken, page = 1, perPage = 15) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        pagination: {}
    };
    
    try {
        const formData = new FormData();
        formData.append('per_page', perPage);
        formData.append('page', page);
        
        const response = await api.post(GET_MAX_INCOME_BONUS, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        console.log("Max Income Bonus Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Max income bonus fetched successfully',
                    pagination: response.data.pagination || {}
                };
            } else {
                result.message = response.data.message || 'Failed to fetch max income bonus';
            }
        }
    } catch (error) {
        console.error("GET_MAX_INCOME_BONUS_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching max income bonus';
    }
    return result;
};

// In Services/Operations/IncomeAPI.js or add to existing API file
export const getLowestIncomeBonusApi = async (authToken, page = 1, perPage = 15) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        pagination: {}
    };
    
    try {
        const formData = new FormData();
        formData.append('per_page', perPage);
        formData.append('page', page);
        
        const response = await api.post(GET_LOWEST_INCOME_BONUS, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        console.log("Lowest Income Bonus Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Lowest income bonus fetched successfully',
                    pagination: response.data.pagination || {}
                };
            } else {
                result.message = response.data.message || 'Failed to fetch lowest income bonus';
            }
        }
    } catch (error) {
        console.error("GET_LOWEST_INCOME_BONUS_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching lowest income bonus';
    }
    return result;
};

// In Services/Operations/IncomeAPI.js or add to existing API file
export const getTeamIncomeListApi = async (authToken, page = 1, perPage = 15) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        pagination: {}
    };
    
    try {
        const formData = new FormData();
        formData.append('per_page', perPage);
        formData.append('page', page);
        
        const response = await api.post(GET_TEAM_INCOME_LIST, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        console.log("Team Income List Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Team income fetched successfully',
                    pagination: response.data.pagination || {}
                };
            } else {
                result.message = response.data.message || 'Failed to fetch team income';
            }
        }
    } catch (error) {
        console.error("GET_TEAM_INCOME_LIST_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching team income';
    }
    return result;
};

// Add this function to your ProductAPI.js file
export const getBinaryIncomeApi = async (authToken, page = 1, perPage = 15) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        pagination: {}
    };
    
    try {
        const formData = new FormData();
        formData.append('per_page', perPage);
        formData.append('page', page);
        
        const response = await api.post(GET_BINARY_INCOME, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        console.log("Binary Income Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Binary income fetched successfully',
                    pagination: response.data.pagination || {}
                };
            } else {
                result.message = response.data.message || 'Failed to fetch binary income';
            }
        }
    } catch (error) {
        console.error("GET_BINARY_INCOME_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching binary income';
    }
    return result;
};

// In Services/Operations/IncomeAPI.js or add to existing API file
export const getDirectLevelIncomeListApi = async (authToken, page = 1, perPage = 15) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        pagination: {}
    };
    
    try {
        const formData = new FormData();
        formData.append('per_page', perPage);
        formData.append('page', page);
        
        const response = await api.post(GET_DIRECT_LEVEL_INCOME_LIST, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            }
        });
        
        console.log("Direct Level Income List Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Direct level income fetched successfully',
                    pagination: response.data.pagination || {}
                };
            } else {
                result.message = response.data.message || 'Failed to fetch direct level income';
            }
        }
    } catch (error) {
        console.error("GET_DIRECT_LEVEL_INCOME_LIST_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching direct level income';
    }
    return result;
};

// Add this constant to your endpoints file

// Helper function to create FormData
const createFormData = (data) => {
    const formData = new FormData();
    for (const key in data) {
        if (data[key] !== undefined && data[key] !== null) {
            formData.append(key, data[key]);
        }
    }
    return formData;
};

// Get Direct Team by User Code (For GenealogyLeadTree)
export const getDirectByUsercodeApi = async (authToken, userCode) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        totalCount: 0
    };
    
    try {
        const formData = createFormData({
            user_code: userCode
        });

        console.log("Get Direct by Usercode API call for user:", userCode);

        // Use direct axios call instead of the pre-configured api instance
        const response = await axios.post('https://global.thewillowquantum.com/api/user/get-direct-by-usercode', formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                // Add CORS headers
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
                'Access-Control-Allow-Headers': 'Content-Type, Authorization'
            },
            withCredentials: false, // Important for CORS
            timeout: 30000 // 30 second timeout
        });
        
        console.log("Get Direct by Usercode Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                // Transform the data to match component structure
             const transformedData = response.data.data.map(item => ({
    id: item.user_code || '',
    name: `${item.first_name || ''} ${item.last_name || ''}`.trim() || 'Unnamed User',
    image: item.profile_photo || null,
    children: [],
    isLoaded: false,
    position: item.position || '',
    isEmpty: !item.user_code,
    firstName: item.first_name || '',
    lastName: item.last_name || '',
    accountName: item.account_name || '',
    email: item.email || '',
    mobile: item.mobile_number || '',
    registrationDate: item.created_at || '',
    status: item.status || 'Active',
    directCount: item.direct_count || 0,
    totalCount: item.total_count || 0,
    package_id: item.package_id,
    // ADD THESE TWO LINES:
    sponsor: item.sponsor || null,
    placement: item.placement || null
}));
                
                result = {
                    status: true,
                    data: transformedData,
                    message: response.data.message || 'Direct team fetched successfully',
                    totalCount: transformedData.length
                };
            } else {
                result.message = response.data.message || 'Failed to fetch direct team';
            }
        }
    } catch (error) {
        console.error("GET_DIRECT_BY_USERCODE_API_ERROR..........", error);
        
        // Check if it's a CORS error
        if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
            result.message = 'CORS/Network Error: Cannot connect to server. Please check if the server allows requests from your origin.';
        } 
        // Handle specific HTTP errors
        else if (error.response?.status === 401) {
            result.message = 'Session expired. Please log in again.';
        } else if (error.response?.status === 404) {
            result.message = 'User not found or no direct team members';
        } else if (error.response?.status === 403) {
            result.message = 'Access forbidden. Please check your permissions.';
        } else if (error.response?.status === 500) {
            result.message = 'Server error. Please try again later.';
        } else if (error.response?.data?.message) {
            result.message = error.response.data.message;
        } else {
            result.message = 'An error occurred while fetching direct team. Please check your connection.';
        }
    }
    return result;
};

// Get Placement by User Code (For GenealogyTree)
export const getPlacementByUsercodeApi = async (authToken, userCode) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        totalCount: 0
    };
    
    try {
        const formData = createFormData({
            user_code: userCode
        });

        console.log("Get Placement by Usercode API call for user:", userCode);

        // Use direct axios call with CORS handling
        const response = await axios.post('https://global.thewillowquantum.com/api/user/get-placement-by-usercode', formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
                'Access-Control-Allow-Headers': 'Content-Type, Authorization'
            },
            withCredentials: false,
            timeout: 30000
        });
        
        console.log("Get Placement by Usercode Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                // Extract left and right volume from response
                const leftVolume = response.data.left_volume || 0;
                const rightVolume = response.data.right_volume || 0;
                
                // Calculate individual volumes for each user from data array
                const userVolumes = {};
                response.data.data.forEach(item => {
                    userVolumes[item.user_code] = {
                        leftVolume: item.left_volume || 0,
                        rightVolume: item.right_volume || 0
                    };
                });
                
                // Transform the data to match component structure
                const transformedData = response.data.data.map(item => ({
                    id: item.user_code || '',
                    name: item.name || `${item.first_name || ''} ${item.last_name || ''}`.trim() || 'Unnamed User', // FIX: Check for name field first
                    image: item.profile_photo || null,
                    children: [],
                    isLoaded: false,
                    position: item.position || '',
                    isEmpty: !item.user_code,
                    firstName: item.first_name || '',
                    lastName: item.last_name || '',
                    accountName: item.account_name || '',
                    email: item.email || '',
                    mobile: item.mobile_number || '',
                    registrationDate: item.created_at || '',
                    status: item.status || 'Active',
                    leftCount: item.left_count || 0,
                    rightCount: item.right_count || 0,
                    level: item.level || 0,
                    package_id: item.package_id,
                    sponsor: item.sponsor || null,
                    placement: item.placement || null,
                    // ADD THESE VOLUME FIELDS:
                    leftVolume: item.left_volume || 0,
                    rightVolume: item.right_volume || 0
                }));
                
                result = {
                    status: true,
                    data: transformedData,
                    message: response.data.message || 'Placement tree fetched successfully',
                    totalCount: transformedData.length,
                    leftVolume: leftVolume,  // Total volumes for this node
                    rightVolume: rightVolume, // Total volumes for this node
                    // ADD THESE FIELDS FROM THE ROOT RESPONSE:
                    name: response.data.name || '', // Add the name field
                    firstName: response.data.first_name || '',
                    lastName: response.data.last_name || '',
                    account_name: response.data.account_name || '',
                    package_id: response.data.package_id || 0
                };
            } else {
                result.message = response.data.message || 'Failed to fetch placement tree';
            }
        }
    } catch (error) {
        console.error("GET_PLACEMENT_BY_USERCODE_API_ERROR..........", error);
        
        // Check if it's a CORS error
        if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
            result.message = 'CORS/Network Error: Cannot connect to server.';
        } 
        // Handle specific HTTP errors
        else if (error.response?.status === 401) {
            result.message = 'Session expired. Please log in again.';
        } else if (error.response?.status === 404) {
            result.message = 'User not found or no placement tree data';
        } else if (error.response?.status === 403) {
            result.message = 'Access forbidden. Please check your permissions.';
        } else if (error.response?.status === 500) {
            result.message = 'Server error. Please try again later.';
        } else if (error.response?.data?.message) {
            result.message = error.response.data.message;
        } else {
            result.message = 'An error occurred while fetching placement tree. Please check your connection.';
        }
    }
    return result;
};

// Alternative method using fetch API (sometimes works better for CORS)
export const getDirectByUsercodeFetch = async (authToken, userCode) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        totalCount: 0
    };
    
    try {
        const formData = new FormData();
        formData.append('user_code', userCode);

        console.log("Get Direct by Usercode (FETCH) API call for user:", userCode);

        const response = await fetch('https://global.thewillowquantum.com/api/user/get-direct-by-usercode', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${authToken}`,
                // Don't set Content-Type header when using FormData, browser sets it automatically
            },
            body: formData,
            mode: 'cors', // Explicitly set CORS mode
            credentials: 'omit' // Don't send cookies
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseData = await response.json();
        
        if (responseData.status === true) {
            const transformedData = responseData.data.map(item => ({
                id: item.user_code || '',
                name: `${item.first_name || ''} ${item.last_name || ''}`.trim() || 'Unnamed User',
                image: item.profile_photo || null,
                children: [],
                isLoaded: false,
                position: item.position || '',
                isEmpty: !item.user_code,
                firstName: item.first_name || '',
                lastName: item.last_name || '',
                accountName: item.account_name || '',
                email: item.email || '',
                mobile: item.mobile_number || '',
                registrationDate: item.created_at || '',
                status: item.status || 'Active',
                directCount: item.direct_count || 0,
                totalCount: item.total_count || 0
            }));
            
            result = {
                status: true,
                data: transformedData,
                message: responseData.message || 'Direct team fetched successfully',
                totalCount: transformedData.length
            };
        } else {
            result.message = responseData.message || 'Failed to fetch direct team';
        }
    } catch (error) {
        console.error("GET_DIRECT_BY_USERCODE_FETCH_ERROR..........", error);
        
        if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
            result.message = 'CORS/Network Error: Cannot connect to server. The server may not be configured to accept requests from your origin.';
        } else {
            result.message = error.message || 'An error occurred while fetching direct team';
        }
    }
    
    return result;
};

// Get Register Payment List (Fuel Deposit)
// export const getRegisterPaymentListApi = async (authToken, filters = {}) => {
//     let result = { 
//         status: false, 
//         data: [], 
//         message: '',
//         summary: {
//             totalAmount: 0,
//             totalCount: 0
//         }
//     };
    
//     try {
//         // Build query parameters
//         const queryParams = new URLSearchParams();
        
//         if (filters.date) {
//             queryParams.append('date', filters.date);
//         }
//         if (filters.month) {
//             queryParams.append('month', filters.month);
//         }
//         if (filters.year) {
//             queryParams.append('year', filters.year);
//         }
        
//         const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
        
//         console.log("Get Register Payment List API call with filters:", filters);
//         console.log("Query string:", queryString);

//         const response = await api.get(`${GET_REGISTER_PAYMENT_LIST}${queryString}`, {
//             headers: {
//                 'Authorization': `Bearer ${authToken}`,
//                 'Accept': 'application/json',
//                 'Content-Type': 'application/json',
//             }
//         });
        
//         console.log("Get Register Payment List Response:", response);
        
//         if (response.data) {
//             if (response.data.status === true) {
//                 // Transform the data
//                 const transformedData = response.data.data.map(item => ({
//                     id: item.id,
//                     paymentMode: item.payment_mode,
//                     paymentHash: item.payment_hash_id,
//                     paymentAmount: item.payment_amount,
//                     paymentReceiveHash: item.payment_receive_hash_id,
//                     paymentStatus: item.payment_status,
//                     paymentComment: item.payment_comment,
//                     statusUpdateAt: item.payment_status_update_at,
//                     createdAt: item.created_at,
//                     firstName: "User",
//                     lastName: "",
//                     accountName: item.payment_receive_hash_id ? item.payment_receive_hash_id.substring(0, 8) : "N/A",
//                     mobile: "N/A",
//                     country: "N/A",
//                     submissionDate: item.created_at,
//                     approvalDate: item.payment_status === "Approved" ? item.payment_status_update_at : null,
//                     status: item.payment_status
//                 }));
                
//                 // Calculate summary
//                 const totalAmount = transformedData.reduce((sum, item) => sum + item.paymentAmount, 0);
//                 const totalCount = transformedData.length;
                
//                 result = {
//                     status: true,
//                     data: transformedData,
//                     message: response.data.message || 'Fuel deposit list fetched successfully',
//                     summary: {
//                         totalAmount,
//                         totalCount
//                     }
//                 };
//             } else {
//                 result.message = response.data.message || 'Failed to fetch fuel deposit list';
//             }
//         }
//     } catch (error) {
//         console.error("GET_REGISTER_PAYMENT_LIST_API_ERROR..........", error);
        
//         // Handle specific HTTP errors
//         if (error.response?.status === 401) {
//             result.message = 'Session expired. Please log in again.';
//         } else {
//             result.message = error.response?.data?.message || 'An error occurred while fetching fuel deposit list';
//         }
//     }
//     return result;
// };

export const getWalletTransactionsApi = async (authToken, walletType, paginationData = {}) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        pagination: {
            current_page: 1,
            last_page: 1,
            per_page: 15,
            total: 0
        }
    };
    
    try {
        const formBody = createFormUrlEncoded({
            wallet_type: walletType,
            per_page: paginationData.per_page || 15,
            page: paginationData.page || 1
        });

        console.log("Get Wallet Transactions API call with:", {
            wallet_type: walletType,
            pagination: paginationData
        });

        const response = await api.post(GET_WALLET_TRANSACTION, formBody, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Get Wallet Transactions Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Transactions fetched successfully',
                    pagination: response.data.pagination || {
                        current_page: 1,
                        last_page: 1,
                        per_page: paginationData.per_page || 15,
                        total: response.data.data?.length || 0
                    }
                };
            } else {
                result.message = response.data.message || 'Failed to fetch transactions';
            }
        }
    } catch (error) {
        console.error("GET_WALLET_TRANSACTIONS_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching transactions';
    }
    return result;
};

// Change Password
export const changePasswordApi = async (authToken, passwordData) => {
    let result = { status: false, message: '' };
    try {
        const formBody = createFormUrlEncoded({
            current_password: passwordData.currentPassword,
            new_password: passwordData.newPassword,
            confirm_password: passwordData.confirmPassword
        });

        console.log("Change Password API call with data:", passwordData);
        console.log("Form body:", formBody);

        const response = await api.post(CHANGE_PASSWORD, formBody, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Change Password Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                data: response.data.data,
                message: response.data.message || 'Password changed successfully'
            };
        } else {
            result.message = response.data?.message || 'Failed to change password';
        }
    } catch (error) {
        console.error("CHANGE_PASSWORD_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while changing password';
    }
    return result;
};

// Helper function to create form-urlencoded data
// const createFormUrlEncoded = (data) => {
//     const formBody = [];
//     for (const property in data) {
//         const encodedKey = encodeURIComponent(property);
//         const encodedValue = encodeURIComponent(data[property]);
//         formBody.push(encodedKey + "=" + encodedValue);
//     }
//     return formBody.join("&");
// };

// In Services/dashboardAPI.js, add these functions:

// Get All Plans
export const getAllPlansApi = async (authToken) => {
    let result = { status: false, data: [], message: '' };
    try {
        const response = await api.get(GET_ALL_PLANS, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            }
        });
        
        console.log("Get All Plans Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data,
                    message: response.data.message || 'Plans fetched successfully'
                };
            } else {
                result.message = response.data.message || 'Failed to fetch plans';
            }
        }
    } catch (error) {
        console.error("GET_ALL_PLANS_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching plans';
    }
    return result;
};

// Get All Plan Amounts
export const getAllPlanAmountsApi = async (authToken) => {
    let result = { status: false, data: [], message: '' };
    try {
        const response = await api.get(GET_ALL_PLAN_AMOUNTS, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            }
        });
        
        console.log("Get All Plan Amounts Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data,
                    message: response.data.message || 'Plan amounts fetched successfully'
                };
            } else {
                result.message = response.data.message || 'Failed to fetch plan amounts';
            }
        }
    } catch (error) {
        console.error("GET_ALL_PLAN_AMOUNTS_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching plan amounts';
    }
    return result;
};

// Add Plan Upgrade API (if different from your existing one)
export const upgradePlanApi = async (authToken, planData) => {
    let result = { status: false, message: '' };
    try {
        const formBody = createFormUrlEncoded(planData);
        
        const response = await api.post(UPGRADE_PLAN, formBody, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Upgrade Plan Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                data: response.data.data,
                message: response.data.message || 'Plan upgraded successfully'
            };
        } else {
            result.message = response.data?.message || 'Failed to upgrade plan';
        }
    } catch (error) {
        console.error("UPGRADE_PLAN_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while upgrading plan';
    }
    return result;
};

// In Services/Operations/ProductAPI.js

// Plan Upgrade API (using main vault)
export const upgradePlanByMainVaultApi = async (authToken, planData) => {
    let result = { status: false, message: '', data: null };
    try {
        // Create URL encoded form data
        const formBody = createFormUrlEncoded(planData);
        
        const response = await api.post(PLAN_UPGRADE_BY_MAIN_VAULT, formBody, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Upgrade Plan by Main Vault Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Plan upgraded successfully'
                };
            } else {
                result.message = response.data.message || 'Failed to upgrade plan';
            }
        }
    } catch (error) {
        console.error("PLAN_UPGRADE_BY_MAIN_VAULT_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while upgrading plan';
    }
    return result;
};

// Submit Registration Payment
export const registerPaymentApi = async (authToken, hashId) => {
    let result = { status: false, data: null, message: '', transactionId: null };
    try {
        const formData = new FormData();
        formData.append('hash_id', hashId);

        const response = await api.post(REGISTER_PAYMENT, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Accept': 'application/json',
            }
        });
        
        console.log("Register Payment Response:", response);
        
        if (response.data) {
            if (response.data.success || response.data.status) {
                result = {
                    status: true,
                    data: response.data.data,
                    message: response.data.message || 'Payment submitted successfully',
                    transactionId: response.data.transaction_id || response.data.data?.transactionId || response.data.id
                };
            } else {
                result.message = response.data.message || 'Payment submission failed';
            }
        }
    } catch (error) {
        console.error("REGISTER_PAYMENT_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while submitting payment';
    }
    return result;
};



// Activate Self by Wallet
export const activateSelfByWalletApi = async (authToken) => {
    let result = { status: false, message: '' };
    try {
        const response = await api.post(ACTIVE_SELF_BY_WALLET, null, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Activate Self by Wallet Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                message: response.data.message || 'Account activated successfully'
            };
        } else {
            result.message = response.data?.message || 'Activation failed';
        }
    } catch (error) {
        console.error("ACTIVATE_SELF_BY_WALLET_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while activating account';
    }
    return result;
};

// Updated API function with correct endpoint and parameters from image
export const creditFuelWalletPaymentSubmitApi = async (authToken, amount, hashId) => {
    let result = { status: false, data: null, message: '' };
    try {
        // Create form data as shown in the image (form-data)
        const formData = new FormData();
        formData.append('amount', amount);
        formData.append('hash_id', hashId);
        
        // Note: The image shows form-data, not x-www-form-urlencoded
        // So we use formData instead of createFormUrlEncoded
        const response = await api.post(FUEL_UP_MAIN_VAULT, formData, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                // Don't set Content-Type for FormData, let browser set it with boundary
            }
        });
        
        console.log("Credit Fuel Wallet Payment Submit Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data || [],
                    message: response.data.message || 'Credit main vault request submitted successfully'
                };
            } else {
                result.message = response.data.message || 'Failed to submit credit request';
            }
        }
    } catch (error) {
        console.error("CREDIT_FUEL_WALLET_PAYMENT_SUBMIT_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while submitting credit request';
        
        // Log more details for debugging
        if (error.response) {
            console.error("Response error:", error.response.data);
            console.error("Response status:", error.response.status);
        }
    }
    return result;
};

// In Services/Operations/ProductAPI.js or create new file

// Get Fuel Wallet Payment List
export const getFuelWalletPaymentListApi = async (authToken, params = {}) => {
    let result = { 
        status: false, 
        data: [], 
        message: '',
        summary: {
            totalAmount: 0,
            totalCount: 0
        }
    };
    
    try {
        const response = await api.get(GET_FUEL_WALLET_PAYMENT_LIST, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            params: params // Pass query parameters for filtering
        });
        
        console.log("Get Fuel Wallet Payment List Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                // Calculate totals from the data
                const dataArray = response.data.data || [];
                const totalAmount = dataArray.reduce((sum, item) => {
                    return sum + (parseFloat(item.payment_amount) || 0);
                }, 0);
                
                result = {
                    status: true,
                    data: dataArray,
                    message: response.data.message || 'Fuel wallet payments fetched successfully',
                    summary: {
                        totalAmount: totalAmount,
                        totalCount: dataArray.length
                    }
                };
            } else {
                result.message = response.data.message || 'Failed to fetch fuel wallet payments';
            }
        }
    } catch (error) {
        console.error("GET_FUEL_WALLET_PAYMENT_LIST_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching fuel wallet payments';
        
        // Handle specific error cases
        if (error.response?.status === 401) {
            result.message = 'Session expired. Please login again.';
        }
    }
    return result;
};

// Get User Profile
export const getUserProfileApi = async (authToken) => {
    let result = { status: false, data: null, message: '' };
    try {
        const response = await api.get(GET_USER_PROFILE, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            }
        });
        
        console.log("Get User Profile Response:", response);
        
        if (response.data) {
            if (response.data.status === true) {
                result = {
                    status: true,
                    data: response.data.data,
                    message: response.data.message || 'Profile fetched successfully'
                };
            } else {
                result.message = response.data.message || 'Failed to fetch profile';
            }
        }
    } catch (error) {
        console.error("GET_USER_PROFILE_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while fetching profile';
    }
    return result;
};

// Login API
// export const loginApi = async (loginData) => {
//     let result ;
//     try {
//         const response = await api.post(LOGIN_API, loginData);
//         console.log("Login API Response:", response);
//         response=result;
       
//     } catch (error) {
//         console.error("LOGIN_API_ERROR..........", error);
//         result.message = error.response?.data?.message || 'An error occurred during login';
//     }
//     return result;
// };

export const loginApi = async (loginData) => {
    let result = {
        status: false,
        message: 'An error occurred during login',
        data: null,  // This will contain all user data
        token: null,
        redirect_url: 'Dashboard'
    };
    
    try {
        const response = await api.post(LOGIN_API, loginData);
        console.log("Login API Response:", response);
        
        if (response.data) {
            result = {
                status: response.data.status || false,
                message: response.data.message || '',
                // Store all user data here
                data: {
                    // Spread any existing data from response.data.data
                    ...(response.data.data || {}),
                    // Add direct properties from response.data
                    name: response.data.name,
                    account_name: response.data.account_name,
                    email: response.data.email,
                    // Include any other direct properties you might need
                    ...(response.data.user_code && { user_code: response.data.user_code }),
                    ...(response.data.transaction_id && { transaction_id: response.data.transaction_id }),
                    // You can add more fields here as needed
                },
                token: response.data.token || null,
                redirect_url: response.data.redirect_url || 'Dashboard'
            };
        }
    } catch (error) {
        console.error("LOGIN_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred during login';
    }
    return result;
};

// Send Forgot Password OTP
export const sendForgotPasswordOtpApi = async (email) => {
    let result = { status: false, message: '' };
    try {
        const response = await api.post(SEND_FORGOT_PASSWORD_OTP, { email });
        console.log("Send OTP Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                message: response.data.message
            };
        } else {
            result.message = response.data?.message || 'Failed to send OTP';
        }
    } catch (error) {
        console.error("SEND_OTP_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while sending OTP';
    }
    return result;
};

// Verify Forgot Password OTP
export const verifyForgotPasswordOtpApi = async (email, otp) => {
    let result = { status: false, message: '' };
    try {
        const response = await api.post(VERIFY_FORGOT_PASSWORD_OTP, { email, otp });
        console.log("Verify OTP Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                message: response.data.message
            };
        } else {
            result.message = response.data?.message || 'Invalid OTP';
        }
    } catch (error) {
        console.error("VERIFY_OTP_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while verifying OTP';
    }
    return result;
};

// Reset Password
export const resetPasswordApi = async (email, password, confirmPassword) => {
    let result = { status: false, message: '' };
    try {
        const response = await api.post(RESET_PASSWORD, { 
            email, 
            password, 
            confirm_password: confirmPassword 
        });
        console.log("Reset Password Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                message: response.data.message
            };
        } else {
            result.message = response.data?.message || 'Failed to reset password';
        }
    } catch (error) {
        console.error("RESET_PASSWORD_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while resetting password';
    }
    return result;
};

// Helper function to create form-urlencoded data
const createFormUrlEncoded = (data) => {
    const formBody = [];
    for (const property in data) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(data[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    return formBody.join("&");
};

// Check Username Availability
export const checkUsernameApi = async (accountName) => {
    let result = { status: false, message: '' };
    try {
        const formBody = createFormUrlEncoded({
            account_name: accountName
        });

        const response = await api.post(CHECK_USERNAME, formBody, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Check Username Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                message: response.data.message || 'Username is available'
            };
        } else {
            result.message = response.data?.message || 'Username already taken';
        }
    } catch (error) {
        console.error("CHECK_USERNAME_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'Error checking username availability';
    }
    return result;
};

// Check Email Availability
export const checkEmailApi = async (email) => {
    let result = { status: false, message: '' };
    try {
        const formBody = createFormUrlEncoded({
            email: email
        });

        const response = await api.post(CHECK_EMAIL, formBody, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Check Email Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                message: response.data.message || 'Email is available'
            };
        } else {
            result.message = response.data?.message || 'Email already registered';
        }
    } catch (error) {
        console.error("CHECK_EMAIL_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'Error checking email availability';
    }
    return result;
};

// Check Mobile Number Availability
export const checkMobileApi = async (nationalNumber, countryName, countryCode) => {
    let result = { status: false, message: '' };
    try {
        const formBody = createFormUrlEncoded({
            mobile_number: nationalNumber || "",
            country_name: countryName || "",
            country_code: countryCode || ""
        });

        console.log('Check Mobile API call with form body:', formBody);

        const response = await api.post(CHECK_MOBILE, formBody, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Check Mobile Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                message: response.data.message || 'Mobile number is available'
            };
        } else {
            result.message = response.data?.message || 'Mobile number already registered';
        }
    } catch (error) {
        console.error("CHECK_MOBILE_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'Error checking mobile number availability';
    }
    return result;
};

// Check User Code (Sponsor/Placement)
export const checkUserCodeApi = async (userCode) => {
    let result = { status: false, data: null, message: '' };
    try {
        const formBody = createFormUrlEncoded({
            user_code: userCode
        });

        const response = await api.post(CHECK_USER_CODE, formBody, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Check User Code Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                data: response.data.data,
                message: response.data.message || 'Valid user code'
            };
        } else {
            result.message = response.data?.message || 'Invalid user code';
        }
    } catch (error) {
        console.error("CHECK_USER_CODE_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'Error checking user code';
    }
    return result;
};

// Check Placement Position
export const checkPlacementPositionApi = async (userCode, position) => {
    let result = { status: false, message: '' };
    try {
        const formBody = createFormUrlEncoded({
            user_code: userCode,
            position: position
        });

        const response = await api.post(CHECK_PLACEMENT_POSITION, formBody, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Check Placement Position Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                message: response.data.message || 'Position is available'
            };
        } else {
            result.message = response.data?.message || 'Position is not available';
        }
    } catch (error) {
        console.error("CHECK_PLACEMENT_POSITION_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'Error checking placement position';
    }
    return result;
};

// Send Email OTP
export const sendEmailOtpApi = async (email, name) => {
    let result = { status: false, message: '' };
    try {
        const formBody = createFormUrlEncoded({
            email: email,
            name: name
        });

        const response = await api.post(SEND_EMAIL_OTP, formBody, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Send Email OTP Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                message: response.data.message || 'OTP sent successfully'
            };
        } else {
            result.message = response.data?.message || 'Failed to send OTP';
        }
    } catch (error) {
        console.error("SEND_EMAIL_OTP_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while sending OTP';
    }
    return result;
};

// Verify Email OTP
export const verifyEmailOtpApi = async (email, otp) => {
    let result = { status: false, message: '' };
    try {
        const formBody = createFormUrlEncoded({
            email: email,
            otp: otp
        });

        const response = await api.post(VERIFY_EMAIL_OTP, formBody, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Verify Email OTP Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                message: response.data.message || 'OTP verified successfully'
            };
        } else {
            result.message = response.data?.message || 'Invalid OTP';
        }
    } catch (error) {
        console.error("VERIFY_EMAIL_OTP_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred while verifying OTP';
    }
    return result;
};

// Complete Registration
export const registerApi = async (registrationData) => {
    let result = { status: false, message: '' };
    try {
        const formBody = createFormUrlEncoded(registrationData);

        console.log('Registration API call with data:', registrationData);
        console.log('Form body:', formBody);

        const response = await api.post(REGISTER, formBody, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        });
        
        console.log("Registration Response:", response);
        
        if (response.data && response.data.status === true) {
            result = {
                status: true,
                message: response.data.message || 'Registration completed successfully'
            };
        } else {
            result.message = response.data?.message || 'Registration failed';
        }
    } catch (error) {
        console.error("REGISTER_API_ERROR..........", error);
        result.message = error.response?.data?.message || 'An error occurred during registration';
    }
    return result;
};